import { UserSearchPaginationDto } from './user-search-pagination.dto';

export class UserSearchPaginationQueryDto extends UserSearchPaginationDto {
  search?: string;
}
